function UserAgent() {
    "use strict";

    this.__type = 'User:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.FirstName = '';
    this.FullName = '';
    this.LastName = '';
    this.OrganizationId = 0
    this.DisplayType = 1;

    this.CultureId = 0;
    this.DataAccessGroupId = -1;
    this.Email = '';
    this.IsActive = true;
    this.SecurityQuestionId = -1;
    this.PasswordPolicy = 0;
    this.PrimaryPhone = '';
    this.SecondaryPhone = '';
    this.ThirdPhone = '';
    this.FourthPhone = '';
    this.PrimarySMSOptInFlag = 0
    this.SecondarySMSOptInFlag = 0
    this.ThirdSMSOptInFlag = 0
    this.FourthSMSOptInFlag = 0
    this.UserName = '';
    // sms feature
    this.SMSOptIn = 0;
    this.TransactionId = '';
    this.TwoFARequiredFlag = 0;
}
if (typeof exports !== 'undefined') {
    module.exports = User;
}